import { render, staticRenderFns } from "./AdminInstitutionView.vue?vue&type=template&id=48b6e1c4&scoped=true"
import script from "./AdminInstitutionView.vue?vue&type=script&lang=js"
export * from "./AdminInstitutionView.vue?vue&type=script&lang=js"
import style0 from "./AdminInstitutionView.vue?vue&type=style&index=0&id=48b6e1c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b6e1c4",
  null
  
)

export default component.exports